import colors from '@/theme/colors';
import { Box, Divider, HStack, Text, VStack } from '@chakra-ui/react';
import React, { PropsWithChildren } from 'react';

export const SectionCard = ({ title, children }: PropsWithChildren<{ title: string }>) => (
  <VStack
    align="stretch"
    width="100%"
    backgroundColor="white"
    borderRadius="8px"
    padding="20px"
    gap="12px"
    boxShadow="0px 2px 2px 0px #7C9EBC40"
  >
    <Text variant="loraSmallTitle">{title}</Text>
    <Divider />
    {children}
  </VStack>
);

export const InfoRow = ({ label, children }: PropsWithChildren<{ label: string }>) => (
  <HStack align="flex-start" justify="space-between" gap="20px" width="100%">
    <Text color={colors.text.mediumGray} fontWeight={600} minWidth="160px">
      {label}
    </Text>
    <Box flex={1} textAlign="right">
      {typeof children === 'string' ? <Text>{children}</Text> : children}
    </Box>
  </HStack>
);
